
import React from 'react'

import { connect } from "react-redux"
import API from '../API'
import { withRouter } from 'react-router'
import constants from "../constants"
import screenActions from '../actions/screen'
import LazyImg from './LazyImg'
import Swipe from 'react-easy-swipe'

import cssAnimations, { events as cssAnimationsEvents } from '../actions/cssAnimations'

const Entities = require('html-entities').AllHtmlEntities; /* to decode html entities for title eg. &#8230; to ... @sh */
const entities = new Entities();

/* fetches more screens from the id specified @jkr */

class Screen extends React.Component {

  constructor(props) {
    super(props);

    this.animateTimeout = -1;

    /* 
     1) get all slugs (it's our bridge table)
     2) fetch the screen id from the slug
     3) fetch the screen from cached screens (allScreens) using the screen id
     4) if the screen is not found, fetch more screens (100 at a time) and cache them
     5) retry getting screen by id
     @jkr
     */
    if (!this.props._store.screen.allSlugs)
      API.instance.fetchFromApi(constants.WORDPRESS_HOME + 'wp-json/row/v1/all-slugs')//?order=asc')
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.props.dispatch(screenActions.setAllSlugsJson(json))
        })
        .catch((error) => {
          console.error(error);
        });
  }

  fetchMoreScreens(page) {

    // const startTime = Date.now();
    API.instance.fetchFromApi('screen', page)
      .then((request) => {
        return request.json();
      })
      .then((json) => {
        // console.log("fetchMoreScreens", (Date.now() - startTime) / 1000)
        this.props.dispatch(screenActions.setAllScreensJson(json));
        // this.props.dispatch(cssAnimations.reset());
      });
  }

  componentDidUpdate() {
    if (this.props._store.screen.activeScreen) {
      if (this.props.match.params.id !== this.props._store.screen.activeScreen.slug)
        this.props.dispatch(screenActions.forceUpdate())
    }

    const info = this.getScreenInfoFromSlug(this.props.match.params.id);
    if (!info) return; //slugs aren't loaded yet, CDU will re run once they are loaded @jkr

    const screen = this.props._store.screen.activeScreen;

    // console.log(this.props._store.api.status);
    if (!screen) this.getScreenById(info.id); //screens aren't loaded yet, this should trigger a load and CDU will udpate after @jkr
  }

  getSlugById(id) {
    const slugs = this.props._store.screen.allSlugs;
    const slug = slugs[id];
    return slug;
  }

  /*
  not actually used to get screen info but rather to get a screen loaded into redux
  @jkr
  */

  getScreenById(id) {
    if (!id) return null;

    const allScreens = this.props._store.screen.allScreens;
    if (allScreens) {
      const keys = Object.keys(allScreens);
      for (let o of keys) {
        const ko = keys[o];
        if (ko && ko.id === id) {
          return ko;
        }
      }
    }

    /* screen wasn't found so let's load the group it's in @jkr */
    const slug = this.getSlugById(id);
    const page = slug.page;
    this.fetchMoreScreens(page);

    return null;
  }

  fetchScreenById(id) {
    // if we are here then there is no screen data @jkr
    API.instance.fetchFromApi('screen', id)
      .then((response) => {
        // console.log(response.url);
        if (response.status !== 200) throw new Error("bad status")
        return response.json();
      })
      .then((json) => {
        if (!json) return;

        this.props.dispatch(screenActions.setAllScreensJson(json));
      }).catch((error) => {
        console.log(error)
      })


    return (
      <div>
        No Screen Data
      </div>
    );
  }

  /*
  gets basic info about the screen: id, etc
  */
  getScreenInfoFromSlug(slug) {
    const slugs = this.props._store.screen.allSlugs;
    if (!slugs) {
      console.log('no slugs');
      return;
    }

    const keys = Object.keys(slugs);
    for (let o of keys) {
      if (slugs[o].slug === slug) return slugs[o];
    }

    return null;
  }

  goBack() {
    this.props.history.goBack();
  }

  goForward() {
    this.props.history.goForward();
  }

  render() {
    const screen = this.props._store.screen.activeScreen;

    let bgImg = '';
    let content = <h1 className="loading flex-container">One Moment...</h1>

    if (screen) {
      bgImg = screen.bgImg;
      content =
        <div>
          <h1 className="title">
            {entities.decode(screen.title.rendered)}
          </h1>

          <div className="content" dangerouslySetInnerHTML={{ __html: entities.decode(screen.body.innerHTML) }}></div>
        </div>

      clearTimeout(this.animateTimeout);
      if (screen && this.props._store.cssAnimations.className !== cssAnimationsEvents.CSS_ANIMATIONS_CLASS) {
        this.animateTimeout = setTimeout(() => {
          this.props.dispatch(cssAnimations.animate());
        }, 1);
      }
    } else {
      if (this.props._store.cssAnimations.className !== cssAnimationsEvents.CSS_ANIMATIONS_PRE_CLASS) {
        this.props.dispatch(cssAnimations.reset());
      }
    }

    return (
      <Swipe
        onSwipeRight={this.goBack.bind(this)}
        onSwipeLeft={this.goForward.bind(this)}
        tolerance={100}
      >
        <div className="screen">
          <LazyImg img={bgImg} />

          {content}
        </div>
      </Swipe>
    );
  }
}

const mapStateToProps = (state) => {
  return { _store: state };
};

export default withRouter(connect(mapStateToProps)(Screen));